import React from 'react'

type Props = {
    error: any
}

export default function PaylinkError({error}: Props) {
    let errorTitle = '';
    let errorContent = <></>;

    if (!error){
        return <></>
    }
    else if (error.error == 'invalid user'){
        errorTitle = 'Unauthorized User';
        errorContent = (
            <p>
            You are not authorized to view this order. Please ask an authorized user to access this payment link.
            </p>
        )
    }
    else if (error.error == 'invalid paylink'){
        errorTitle = 'Invalid Payment Link';
        errorContent = (
            <p>
                This payment link is either invalid or has already
                been completed. If you believe you are seeing this in error, please&nbsp;
                <a href="https://support.borisfx.com/hc/en-us/requests/new?ticket_form_id=8863752433421">
                    contact us.
                </a>
            </p>
        )
    }
    else if (error.error == 'opp closed'){
        errorTitle = 'Payment Already Received';
        errorContent = (
            <p>
                We have already received payment for this order, so there is nothing left to pay.
                If you believe you are seeing this in error, please&nbsp;
                <a href="https://support.borisfx.com/hc/en-us/requests/new?ticket_form_id=8863752433421">
                    contact us.
                </a>
            </p>
        )
    }
    else if (error.error == 'no payment due'){
        errorTitle = 'No Payment Due';
        errorContent = (
            <p>
                There is no balance due on this order. If you believe you are seeing this in error, please&nbsp;
                <a href="https://support.borisfx.com/hc/en-us/requests/new?ticket_form_id=8863752433421">
                    contact us.
                </a>
            </p>
        )
    }
    else {
        errorTitle = 'Something Went Wrong';
        errorContent = (
            <p>
                We were unable to load this payment link. Please&nbsp;
                <a href="https://support.borisfx.com/hc/en-us/requests/new?ticket_form_id=8863752433421">
                    contact us.
                </a>
            </p>
        )
    }

    return (
        <div className='box box-accent' style={{maxWidth: '500px', padding: '32px', margin: '0 auto'}}>
            <h2>{errorTitle}</h2>
            {errorContent}
        </div>
    )
}